import { Scene } from '@/typings/domain'
import { useColorScheme } from 'nativewind'
import { Image, StyleSheet } from 'react-native'

import FormDark from '@/assets/images/covers/dark/form.svg'
import SurveyDark from '@/assets/images/covers/dark/survey.svg'
import RegistryDark from '@/assets/images/covers/dark/registry.svg'
import VoteDark from '@/assets/images/covers/dark/vote.svg'
import ExamDark from '@/assets/images/covers/dark/exam.svg'
import ReservationDark from '@/assets/images/covers/dark/reservation.svg'
import CustomerAcquisitionDark from '@/assets/images/covers/dark/customer_acquisition.svg'
import EvaluationDark from '@/assets/images/covers/dark/evaluation.svg'
import OnlinePaymentDark from '@/assets/images/covers/dark/online_payment.svg'

type FormIconProps = {
  scene?: Scene
}

export default function FormIcon({ scene = Scene.Form }: FormIconProps) {
  const { colorScheme } = useColorScheme()
  const isDark = colorScheme === 'dark'

  switch (scene) {
    case Scene.Survey:
      return isDark ? (
        <SurveyDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/survey.png')} />
      )
    case Scene.Registry:
      return isDark ? (
        <RegistryDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/registry.png')} />
      )
    case Scene.Vote:
      return isDark ? (
        <VoteDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/vote.png')} />
      )
    case Scene.Exam:
      return isDark ? (
        <ExamDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/exam.png')} />
      )
    case Scene.Reservation:
      return isDark ? (
        <ReservationDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/reservation.png')} />
      )
    case Scene.CustomerAcquisition:
      return isDark ? (
        <CustomerAcquisitionDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/customer_acquisition.png')} />
      )
    case Scene.Evaluation:
      return isDark ? (
        <EvaluationDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/evaluation.png')} />
      )
    case Scene.OnlinePayment:
      return isDark ? (
        <OnlinePaymentDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/online_payment.png')} />
      )
    default:
      return isDark ? (
        <FormDark width={48} height={48} />
      ) : (
        <Image style={styles.formIcon} source={require('@/assets/images/covers/form.png')} />
      )
  }
}

const styles = StyleSheet.create({
  formIcon: {
    width: 48,
    height: 48,
  },
})
